/**
 * @file Renew-contract coach: its Summary step's Finish sends the renewal, and a 200 or 207 closes it onto the new contract's page.
 * Failure path: any other answer keeps it on Summary, its fields marked from the coach's own state and the saga showing the message.
 */
import * as React from "react";
import Component from "../../AbstractComponent";
import { getLabelForField } from "../../../Entity/Entities/Contract/FieldLabels";
import { getChargeTemplatesForRenewal } from "../../../Entity/Entities/Contract/RenewalChargeTemplates";
// import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import TextField from "../Material/TextField";
import ContractLookup from "../Lookup/ContractLookup";
import PersonLookup from "../Lookup/PersonLookup";
// import UnitLookup from "../Lookup/UnitLookup";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import Constants from "../../../Action/Constants";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { Occupant as OccupantType } from "../../../Entity/Entities/ContactForContract/Type/Types/Occupant";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
// import { PromptDialog } from "./PromptDialog";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import { PageTransition } from "../Spinner/PageTransition";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';

import Time from "../../../Time/Time";
import Formatter from "../../../Localization/Formatter";
import * as uuidV4 from "uuid/v4";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Searchbar from "../../Partials/Searchbar/Searchbar";
// import { ContactForContractInterface } from "../../../Entity/Entities/ContactForContract/ContactForContractInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
// import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import PersonFactory from "../../../Entity/Factories/PersonFactory";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { FirstDayOfPeriod } from "../../../Entity/Entities/Charge/PaymentOffset/Offsets/FirstDayOfPeriod";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

export class CoachRenewContract extends Component {
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachRenewContract: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    errorMessage: null,
    selectedUnit: null,
    amazonFolderName: uuidV4(),
    firstName: "",
    tenantChoice: "newtenant",
    lastName: "",
    tenantType: "person",
    tenant: null,
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    companyTenant: null,
    showNextButton: false,
    isSaving: false,
    isClosePreprocessDialogOpen: false,
    successfullyUpdated: false,

    //Occupant data
    occupantFirstName: "",
    occupantLastName: "",
    occupantDescription: this.trans("label-occupant"),
    occupantError: null,
    occupantsData: [],
    showAdditionalSection: false,
    defaultAgencyFees: [],
    ignoredPeople: [],
    occupantChoice: "newoccupant",
    selectedOccupant: null,

    //Contract data
    contract: null,
    finalRentalPeriodDate: null,
    expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
    rentNotificationText: this.trans("notification_rent_message"),
    lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
    status: this.props.app.contractStatuses['CONCEPT'],
    note: "",
    firstDate: Time.firstDateNextMonth(),
    endDate: null,
    isSetPaymentUntilDateChecked: false,
    payChargesUntilDate: Time.lastDatePreviousMonth(),
    additionalFields: [],
    lastSelectedIndex: null,
    autoSendInvoiceToTenant: false,
    isCommercial: false,
    selectedTenant: null,
    newContract: null,

    //Charge template data
    chargeTemplates: [],
    newChargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    priceOldAmount: "",
    priceNewAmount: "",
    pricePercentage: "0",
    chargeTemplateInitialAmounts: {},
    selectedChargeIndex: null,

    extensionDate: Time.firstDateNextMonth(),
    error: null,
    datepickerHint: this.trans("last-date-of-period-pretty-close"),
    datepickerError: "",
    tooltipOpen: false,
    disabledNext: false
  };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openCoachRenewContract: this.props?.openCoachRenewContract,
    });
    if (this.props.contract) {
      this.setState({
        ...this.getStateForContract(this.props.contract),
        activeStep: 1
      });
    }
  }

  // The rows and dates of a renewal of `contract`, the same for a contract handed in and one picked in the first step.
  public getStateForContract = (contract: ContractInterface) => {
    const chargeTemplates = getChargeTemplatesForRenewal(contract?.chargeTemplates).map((template: any) => {
      return {
        amount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
        currency: template?.currency?.getCurrencyId(),
        type: template?.type?.id,
        repeatPeriod: template?.repeatPeriod?.id,
        description: template?.description,
        paymentOffset: template?.paymentOffset?.getValue(),
        dueDateFirstPayment: Time.firstDateNextMonth(),
        firstDate: Time.firstDateNextMonth(),
        endDate: null,
        isDefault: false,
        oldAmount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
        isDummyPay: template?.isDummyPay,
        contactId: template?.contactId,
        companyId: template?.companyId,
        isCollective: template?.isCollective,
        isChanged: false,
        percentage: "0",
        editedAmount: parseFloat(Formatter.simpleFormatNumber(template.amount)),
        buttonDisabled: true,
        paymentRouteId: template?.paymentRouteId
      };
    });

    const additionalFields = [];
    contract?.occupants.forEach(occupant => {
      if (!occupant) {
        return;
      }
      additionalFields.push({
        selectedPerson: occupant?.person,
        description: occupant?.description,
        contactForContractTypeId: occupant?.contactForContractTypeId
      });
    });

    return {
      contract,
      chargeTemplates,
      showNextButton: true,
      selectedTenant: contract?.tenant,
      selectedUnit: contract?.unit,
      tenantChoice: "existingtenant",
      additionalFields,
      extensionDate: Time.firstDateNextMonth(),
      lastDate: contract?.lastDate,
      finalRentalPeriodDate: contract?.finalRentalPeriodDate,
      expirationDate: Time.nextYearPrevMonthLastDay(Time.substractMonth(Time.nextDayFromDate(this.state.firstDate), this.props.app.settings.agency.notificationPeriod - 1))
    };
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachRenewContract: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      errorMessage: null,
      selectedUnit: null,
      amazonFolderName: uuidV4(),
      firstName: "",
      tenantChoice: "newtenant",
      lastName: "",
      tenantType: "person",
      tenant: null,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      companyTenant: null,
      showNextButton: false,
      isSaving: false,
      isClosePreprocessDialogOpen: false,
      successfullyUpdated: false,

      //Occupant data
      occupantFirstName: "",
      occupantLastName: "",
      occupantDescription: this.trans("label-occupant"),
      occupantError: null,
      occupantsData: [],
      showAdditionalSection: false,
      occupantChoice: "newoccupant",

      //Contract data
      contract: null,
      finalRentalPeriodDate: null,
      expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
      lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
      status: this.props.app.contractStatuses['CONCEPT'],
      note: "",
      firstDate: Time.firstDateNextMonth(),
      endDate: null,
      isSetPaymentUntilDateChecked: false,
      payChargesUntilDate: Time.lastDatePreviousMonth(),
      additionalFields: [],
      autoSendInvoiceToTenant: false,
      isCommercial: false,
      selectedTenant: null,
      newContract: null,

      chargeTemplates: [],
      isChargeTemplatePopupOpen: false,
      newChargeTemplatePopupOpen: null,
      anchorElChargeTemplate: null,
      selectedChargeTemplate: null,
        priceOldAmount: "",
      priceNewAmount: "",
      pricePercentage: "0",
      chargeTemplateInitialAmounts: {},
      selectedChargeIndex: null,

      extensionDate: Time.firstDateNextMonth(),
      error: null
    });
  }

  protected getErrorFor(
    field: string,
    errorFields: string[] = this.state.errorFields || [],
    translatedMessage: string = this.state.errorMessage,
    displayName: string = this.getLabelFor(field)
  ): any {
    return super.getErrorFor(field, errorFields, translatedMessage, displayName);
  }

  public getLabelFor = (field: string): string => {
    return getLabelForField(field, this.trans);
  }

  // The control's `id`, `name`, scroll class and backend error, all from its request-body path.
  public getFieldPropsFor = (path: string) => {
    return {
      id: path,
      name: path,
      className: `scroll-to-${path}`,
      error: this.getErrorFor(path)
    };
  }

  public onCloseRenewContractCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => { this.clearState() }, 100);

    if (this.props.onCloseRenewContractCoach) {
      this.props.onCloseRenewContractCoach.call(this, this.state.newContract, this.state.successfullyUpdated);
    }
  }

  /* Logic for open other coaches */
  public openUnitCoachDialog = () => {
    if (this.props.openUnitCoachDialog) {
      this.props.openUnitCoachDialog.call(this);
    }
  }

  public renewContract = () => {
    const payload: any = {
      сreatedOnFrontend: true,
      id: this.state.contract?.id,
      unit: this.state?.selectedUnit,
      amazonFolderName: this.state.amazonFolderName,
      extensionDate: this.state.extensionDate,
      lastDate: this.state.lastDate,
      finalRentalPeriodDate: this.state.finalRentalPeriodDate,
      endDate: this.state.endDate,
      expirationDate: this.state.expirationDate,
      text: this.state.rentNotificationText,
      payChargesUntilDate: this.state.isSetPaymentUntilDateChecked === true ? this.state.payChargesUntilDate : null,
      note: this.state?.contract?.note,
      referenceForTenant: this.state?.contract?.referenceForTenant,
      chargeTemplates: this.state.chargeTemplates
        .filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate?.unitId),
      additionalFields: this.state?.additionalFields,
      agencyFee: this.state?.contract?.defaultAgencyFees[0],
      autoSendInvoiceToTenant: this.state?.contract?.autoSendInvoiceToTenant,
      isCommercial: this.state?.contract?.isCommercial,
    };

    if (this.state?.selectedTenant instanceof Person) {
      payload.selectedPerson = this.state?.selectedTenant;
    }

    if (this.state?.selectedTenant instanceof Company) {
      payload.selectedCompany = this.state?.selectedTenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_EXTEND_START,
        payload: {
          ...payload
        },
        getLabelFor: this.getLabelFor,
        onSuccess: (contract) => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
          this.setState({
            error: null,
            isSaving: false,
            successfullyUpdated: true,
            newContract: contract
          }, this.onCloseRenewContractCoach)
        },
        onError: (err) => {
          let chargeTemplatesErrorRows = [];

          let chargeTemplatesErrorIndexRows = err.fields?.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field => parseInt(field.match(/\d+/)));

          let chargeTemplatesError = err.fields?.filter(field => field.indexOf("chargeTemplates") === 0)
          if (chargeTemplatesError[0]) {
            chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
          }



          const chargeTemplates = this.state.chargeTemplates?.map((chargeTemplate, index) => {
            return {
              ...chargeTemplate,
              error: chargeTemplatesErrorRows.some(field => field === index),
              isPriceCorrected: false
            }
          })

          this.setState({
            chargeTemplates: chargeTemplates,
            isSaving: false,
            hasModifiedData: true,
            error: err,
            errorFields: err.fields,
            errorMessage: err.translatedMessage,
            scrollToError: ""
          })
        }
      });
    });
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [
      this.trans("coach/renew-contract/first-title"),
      this.trans("coach/renew-contract/second-title"),
      this.trans("coach/renew-contract/third-title"),
      this.trans("coach/renew-contract-step/step4-title"),
      this.trans("summary"),
    ];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      case 4:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
        {step === 4 && this.fifthStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/renew-contract-step/step1-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/renew-contract-step/step1-subtitle")}
        />
        <div>
          <ContractLookup
            {...this.props}
            id="contractId"
            name="contractId"
            ref="ContractLookup"
            className="scroll-to-contractId"
            styleInModal={"styleInModal"}
            disableEntityCreation={true}
            onSelect={this.selectContract}
            onClear={this.clearContract}
            autoFocus={false}
            hideClickThroughLink={true}
            filterSignedAndExpiring={true}
            autoSelectId={this.state.contract?.id}
          />
        </div>
      </div>
    )
  }

  public secondStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/renew-contract-step/step2-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/renew-contract-step/step2-subtitle")}
        />

        <div>
          {
            <RadioGroup
              name="chargeOwnerChoice"
              className="filters-container"
              value={this.state.tenantChoice}
              onChange={this.changeTenantChoice}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start"
              }}
            >
              <FormControlLabel
                control={<Radio color="primary" />}
                value="newtenant"
                label={this.trans("coach/newcontract-step/first-newtenant/label")}
                style={{ width: "auto", fontSize: "16px" }}
              />

              <FormControlLabel
                control={<Radio color="primary" />}
                value="existingtenant"
                label={this.trans("coach/newcontract-step/first-existingtenant/label")}
                style={{ width: "auto", fontSize: "16px" }}
              />
            </RadioGroup>
          }

          {this.state.tenantChoice === "existingtenant" ?
            <div className="search-bar-container">
              <Searchbar
                {...this.props}
                name="personId"
                className="scroll-to-mainTenantContactId"
                id="selectedTenantForContract"
                ref="TenantLookup"
                floatingLabelText={this.trans("label-tenant")}
                allResults={true}
                objectField={true}
                onChange={this.selectTenant}
                onClear={this.clearTenant}
                selectedEntity={this.state.selectedTenant}
                searchParameter={"contactsSearch"}
                error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                showClickThroughLink={false}
                searchText={this.state.selectedTenant ? `${this.state.selectedTenant?.nameOfEntity}, ${this.state.selectedTenant?.displayName}` : null}
                styleInModal={"pick-object-modal"}
              />
            </div>
            :
            <div>
              <div>
                {this.trans("coach/propertyowner-scenario/tenant-step/first-choosetype")}
              </div>
              <RadioGroup
                className="filters-container"
                value={this.state.tenantType}
                onChange={this.chooseTenantType}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  // width: "500px",
                  paddingLeft: "0px"
                }}
              >
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="person"
                  label={this.trans("coach/propertyowner-radiobutton/person")}
                  style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
                />
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="company"
                  label={this.trans("coach/propertyowner-radiobutton/company")}
                  style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
                />
              </RadioGroup>
              {this.state.tenantType === "person" &&
                <div>
                  <p className="info-text">
                    {this.trans("coach/newpropertyfirstuser-step/tenant-info1")}
                  </p>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div>
                      <TextField
                        autoComplete="off"
                        // id="firstName"
                        // name="firstName"
                        className="form-element full-size scroll-to-firstName"
                        type="text"
                        autoFocus={true}
                        label={this.trans("label-first-name")}
                        value={this.state.tenantFirstName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                        variant="standard"
                        error={!!this.getErrorFor("firstName") && !this.state.occupantError}
                        style={{ minWidth: "250px" }}
                      />
                      {(!!this.getErrorFor("firstName") && !this.state.occupantError) && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}
                    </div>
                    <TextField
                      autoComplete="off"
                      // id="lastName"
                      // name="lastName"
                      className="form-element full-size scroll-to-lastName"
                      type="text"
                      label={this.trans("label-last-name") + this.trans("field/optional")}
                      value={this.state.tenantLastName}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                      variant="standard"
                      error={!!this.getErrorFor("lastName")}
                      style={{ minWidth: "190px", marginLeft: "16px" }}
                    />
                  </div>
                  <div className="hint-styles">
                    {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
                  </div>
                </div>
              }
              {
                this.state.tenantType === "company" &&
                <div>
                  <TextField
                    autoComplete="off"
                    className="form-element full-size"
                    type="text"
                    label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                    value={this.state.companyNameTenant}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyNameTenant")}
                    variant="standard"
                    autoFocus={true}
                    error={this.getErrorFor("name")}
                  />
                  {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
                  <p style={{ marginTop: "25px" }} className="info-text">
                    {this.trans("coach/newpropertyfirstuser-step/tenant-info3")}
                  </p>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div>
                      <TextField
                        autoComplete="off"
                        // id="firstName"
                        // name="firstName"
                        className="form-element full-size scroll-to-firstName"
                        type="text"
                        label={this.trans("label-first-name")}
                        value={this.state.tenantFirstName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                        variant="standard"
                        error={!!this.getErrorFor("contacts.firstName")}
                        style={{ minWidth: "250px" }}
                      />
                      {!!this.getErrorFor("contacts.firstName") && <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div>}
                    </div>
                    <TextField
                      autoComplete="off"
                      // id="lastName"
                      // name="lastName"
                      className="form-element full-size scroll-to-lastName"
                      type="text"
                      label={this.trans("label-last-name") + this.trans("field/optional")}
                      value={this.state.tenantLastName}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                      variant="standard"
                      error={!!this.getErrorFor("contacts.lastName")}
                      style={{ minWidth: "190px", marginLeft: "16px" }}
                    />
                    {!!this.getErrorFor("contacts.lastName") && <div className="component-error-text">{this.getErrorFor("contacts.lastName")}</div>}
                  </div>
                  <div className="hint-styles">
                    {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
                  </div>
                </div>
              }

              <div className="coach-new-property-save-button" style={{ marginBottom: "16px" }}>
                <Button
                  color="primary"
                  onClick={this.createTenant}
                  variant="contained"
                  style={{ textAlign: "right" }}
                >
                  {this.trans("button-save")}
                </Button>
              </div>
            </div>
          }
        </div>

        {this.state.tenantChoice === "existingtenant" &&
          <>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {this.renderAdditionalFields()}
            </div>
          </>
        }
      </div>
    );
  }

  public thirdStepDetails = () => {
    return (
      <div className="coach-content-wrapper" style={{ width: "650px", maxWidth: "unset" }}>
        <Title
          title={this.trans("coach/renew-contract-step/step3-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/renew-contract-step/step3-subtitle", { unitShortDisplayName: this.state.contract?.unit?.shortDisplayName || this.state.contract?.unit?.displayName })}
        />
        <div style={{ display: "flex", flexDirection: "column" }}>
          {this.state.chargeTemplates?.length > 0 &&
            <ul style={{ margin: 0, width: "100%", padding: 0 }}>
              {
                this.state.chargeTemplates?.map((chargeTemplate, index) => {
                  const amountField = this.getFieldPropsFor(`chargeTemplates[${index}].amount`);
                  const amountError = chargeTemplate.isPriceCorrected ? "" : amountField.error;


                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", width: "100%", marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "auto", position: "relative" }}>
                          <li style={{ margin: "0", listStyle: "none", fontSize: "16px" }}> {chargeTemplate.error &&
                            <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                              <span
                                className="icon icon-ic-info red"
                              >
                              </span>
                            </span>
                          }{`${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate.oldAmount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}${chargeTemplate?.isChanged ? ", " : ""}`}
                            {chargeTemplate.isChanged ? <span style={{ color: "green", fontSize: "16px" }}>{this.trans("title-new")}: {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}</span> : ""}
                          </li>
                          <div
                            className="icon icon-ic-close clear-button"
                            style={{
                              display: "inline-block",
                              position: "absolute",
                              right: "-25px",
                              cursor: "pointer",
                              top: "-1px"
                            }}
                            onClick={this.removeChargeTemplate.bind(this, index)}
                          ></div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("page/renewcontract-dialog/calculateprice-field/oldamount-label")}
                                value={chargeTemplate?.oldAmount}
                                disabled={true}
                                variant="standard"
                                error={false}
                              />
                            </div>

                            <div className="form-element full-size no-margins margin-sides-20">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("page/renewcontract-dialog/calculateprice-field/percentage-label")}
                                onChange={(e) => this.changePricePercentage(e, index)}
                                value={chargeTemplate?.percentage}
                                variant="standard"
                                error={false}
                              />
                            </div>

                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                id={amountField.id}
                                name={amountField.name}
                                className={`form-element full-size ${amountField.className}`}
                                type="text"
                                label={this.trans("page/renewcontract-dialog/calculateprice-field/newamount-label")}
                                value={chargeTemplate?.editedAmount}
                                onChange={(e) => this.changePriceNewAmount(e, index)}
                                autoFocus={index === 0}
                                variant="standard"
                                error={!!amountError}
                              />
                              {!!amountError && <div className="component-error-text">{amountError}</div>}
                            </div>
                            <Button
                              color="primary"
                              onClick={() => this.updatePrice(index)}
                              variant="contained"
                              disabled={chargeTemplate?.buttonDisabled}
                              style={{ marginLeft: "20px" }}
                            >
                              {this.trans("button-save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              }
            </ul>
          }
          {this.state.newChargeTemplates?.length > 0 &&
            <ul style={{ margin: 0, width: "100%", padding: 0 }}>
              {
                this.state.newChargeTemplates?.map((chargeTemplate, index) => {
                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", width: "100%", marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "auto", position: "relative" }}>
                          <li style={{ margin: "0", listStyle: "none", fontSize: "16px" }}> {chargeTemplate.error &&
                            <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                              <span
                                className="icon icon-ic-info red"
                              >
                              </span>
                            </span>
                          }{`${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate.oldAmount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}${chargeTemplate?.isChanged ? ", " : ""}`}
                            {chargeTemplate.isChanged ? <span style={{ color: "green", fontSize: "16px" }}>{this.trans("title-new")}: {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}</span> : ""}
                          </li>
                          <div
                            className="icon icon-ic-close clear-button"
                            style={{
                              display: "inline-block",
                              position: "absolute",
                              right: "-25px",
                              cursor: "pointer",
                              top: "-1px"
                            }}
                            onClick={this.removeNewChargeTemplate.bind(this, index)}
                          ></div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Select
                              className="form-element full-size form-input scroll-to-type correct-label-position"
                              style={{ minWidth: "190px", marginRight: "16px" }}
                              error={this.getErrorFor("type")}
                              value={chargeTemplate?.type}
                              onChange={(event) => this.setChargeTemplateType(event, index)}
                              htmlFor="type"
                              label={this.trans("dialog/defaultchargetemplates-field/type-label")}
                              name="type"
                              id="type"
                            >
                              {
                                TypeContainer.getChargeTypesForChargeTemplates("contract").map((type, index) => {
                                  return (
                                    <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                                  );
                                })
                              }
                            </Select>
                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("label-amount")}
                                value={chargeTemplate?.editedAmount}
                                onChange={(event) => this.setNewChargeAmount(event, index)}
                                disabled={false}
                                variant="standard"
                                error={false}
                              />
                            </div>

                            <Select
                              className="form-element full-size form-input scroll-to-currency correct-label-position"
                              error={this.getErrorFor("currency")}
                              style={{ margin: "0 16px", maxWidth: "100px" }}
                              value={chargeTemplate?.currency}
                              htmlFor="currency"
                              label={this.trans("dialog/defaultchargetemplates-field/currency-label")}
                              name="currency"
                              id="currency"
                              disabled={true}
                            >
                              {this.getCurrencySelectboxes()}
                            </Select>

                            <Select
                              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
                              style={{ maxWidth: "110px" }}
                              error={this.getErrorFor("repeat-period")}
                              value={chargeTemplate?.repeatPeriod}
                              onChange={(event) => this.setChargeTemplateRepeatPeriod(event, index)}
                              htmlFor="repeatPeriod"
                              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                              name="repeatPeriod"
                              id="repeatPeriod"
                            >
                              {this.getRepeatPeriodSelectboxes()}
                            </Select>

                            <Button
                              color="primary"
                              onClick={() => this.saveNewChargeTemplate(index)}
                              variant="contained"
                              disabled={chargeTemplate?.buttonDisabled}
                              style={{ marginLeft: "20px" }}
                            >
                              {this.trans("button-save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              }
            </ul>
          }
        </div>
        {this.state.newChargeTemplates.length === 0 &&
          <Button
            color="primary"
            onClick={this.addNewChargeTemplate}
            variant="contained"
          >
            {this.trans("button-add")}
          </Button>
        }
      </div>
    );
  }

  public fourthStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/renew-contract-step/step4-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/renew-contract-step/step4-subtitle", { unitShortDisplayName: this.state.contract?.unit?.shortDisplayName || this.state.contract?.unit?.displayName })}
        />
        <DatePickerComponent
          {...this.props}
          {...this.getFieldPropsFor("extensionDate")}
          label={this.trans("first-date")}
          initialDate={this.state.extensionDate}
          onChange={date => this.selectDate(date, "extensionDate")}
          minDate={this.state.contract?.firstDate < Time.currentMonthStartMinusYears(1) ?
            Time.currentMonthStartMinusYears(1) : this.state.contract?.firstDate}
          minDatePlusDays={this.state.contract?.firstDate < Time.currentMonthStartMinusYears(1) ? 0 : 1}
          maxDate={Time.currentDatePlusYears(1)}
          clearButton={false}
          width="60%"
        />

        {/* <div style={{display: "flex", alignItems: "center"}}>
          <div className="wrapper-for-field" style={{width: "60%", position: "relative"}}>
            <DatePickerComponent
              {...this.props}
              name="lastDate"
              className="scroll-to-lastDate"
              label={this.trans("expiration-date") + " 1" + Time.getDatepickerHint() + this.trans("field/optional")}
              initialDate={this.state.lastDate}
              onChange={date => this.selectDate(date, "lastDate")}
              minDate={this.state.extensionDate}
              minDatePlusDays={1}
              minDateMessage={this.trans("field/lastfinalenddate-info/error")}
              hint={this.state.datepickerHint}
              clearButton={true}
              error={this.state.datepickerError}
              margin={"7px 0px 0px 0px"}
              width="100%"
            />
            <div className={`block-tooltip ${this.state.tooltipOpen ? 'open-tooltip' : 'close-tooltip'}`}  onClick={this.openTooltip}>
              <div id="tooltip-block" className="tooltip-icon">?</div>
              <span id="hidden-hint" className="hidden">{this.trans("page/contracts-hint/lastdate-info")}</span>
            </div>
          </div>
          {this.renderNotificationDateQuicksets()}
        </div> */}

        {/* <DatePickerComponent
          {...this.props}
          id="finalDate"
          name="finalDate"
          className="scroll-to-finalRentalPeriodDate"
          label={this.trans("expiration-date") + " 2" + Time.getDatepickerHint() + this.trans("field/optional")}
          initialDate={this.state.finalRentalPeriodDate}
          onChange={date => this.selectDate(date, "finalRentalPeriodDate")}
          minDate={this.state.extensionDate}
          minDatePlusDays={1}
          minDateMessage={this.trans("field/lastfinalenddate-info/error")}
          clearButton={true}
          width="60%"
          error={this.getErrorFor("finalRentalPeriodDate")}
          margin={"7px 0px 0px 0px"}
        /> */}

        {/* <div style={{ display: "flex", alignItems: "center" }}>
          <DatePickerComponent
            {...this.props}
            id="expirationDate"
            name="expirationDate"
            className="scroll-to-expirationDate"
            label={this.trans("contract-expiration-date") + this.trans("field/optional")}
            initialDate={this.state.expirationDate}
            value={this.state.expirationDate}
            minDate={this.state.extensionDate < new Date() ? new Date() : this.state.extensionDate}
            minDatePlusDays={0}
            onChange={date => this.selectDate(date, "expirationDate")}
            clearButton={true}
            width="60%"
            error={this.getErrorFor("expirationDate")}
            margin={"7px 0px"}
          />

        </div>

        <TextField
          type="text"
          className="form-element"
          value={this.state.rentNotificationText}
          onChange={(e) => this.setState({ rentNotificationText: e.target.value, hasModifiedData: true })}
          label={this.trans("dialog-new-notification-text")}
          style={{ width: "60%" }}
        /> */}
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.isCommercial}
                onChange={this.changeIsCommercial}
                color="primary"
              />
            }
            label={this.trans("page/contracts-label/iscommercialcontract", { vatPercentage: this.props?.app?.settings?.agency?.vatPercentage })}
          />
        </div>

        <div style={{ paddingBottom: "20px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.autoSendInvoiceToTenant}
                onChange={this.changeAutoSendInvoiceToTenant}
                color="primary"
              />
            }
            label={this.trans("page/contracts-label/automaticallysendrentinvoice")}
          />
        </div>
      </div>
    )
  }

  public fifthStepSummary = () => {
    let summaryArr = [];

    if (this.state.chargeTemplates?.length > 0) {
      this.state.chargeTemplates?.forEach((chargeTemplate, index) => {
        const type = Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system);
        const oldAmount = this.formatter.formatNumber(chargeTemplate.oldAmount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency));
        const amount = this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency));
        const amountEqualOldAmount = chargeTemplate.oldAmount === chargeTemplate.amount;
        summaryArr.push({
          label: index === 0 ? this.trans("title-contract-prices") : "",
          value: <p>{type}&nbsp;{oldAmount}{!amountEqualOldAmount ? <>, <b>{this.trans("title-new").toLowerCase()}</b> {amount}</> : ""}</p>
        });
      })
    }

    if (this.state.extensionDate) {
      summaryArr.push({
        label: this.trans("coach/increaserent-step/start-date"),
        value: this.formatter.formatDate(this.state.extensionDate)
      });
    }

    if (this.state.expirationDate) {
      summaryArr.push({
        label: this.trans("contract-expiration-date"),
        value: this.formatter.formatDate(this.state.expirationDate)
      });
    }

    if (this.state.selectedUnit) {
      summaryArr.push({
        label: this.trans("title-unit"),
        value: this.state.selectedUnit?.displayName
      });
    }

    if (this.state.selectedTenant) {
      summaryArr.push({
        label: this.trans("title-tenant"),
        value: this.state.selectedTenant?.displayName
      });
    }

    if (this.state.additionalFields?.length > 0) {
      this.state.additionalFields?.forEach((field, index) => {
        summaryArr.push({
          label: `${this.trans("title-tenant")} ${index + 2}`,
          value: field?.selectedPerson?.displayName
        });
      })
    }

    return summaryArr;
  }

  public fifthStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/moveunit-step/second-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-update-subtitle-dutch-het", { entity: this.trans("title-contract").toLowerCase() })}
        />
        <div>
          <CoachSummaryTable
            tableRows={this.fifthStepSummary()}
          />
        </div>
      </div>
    )
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.contractStartStep1();
  }

  public startStep2 = () => {
    return this.contractStartStep2();
  }

  public startStep3 = () => {
    return this.contractStartStep3();
  }

  public startStep4 = () => {
    return this.contractStartStep4();
  }

  public startStep5 = () => {
    return this.contractStartStep5();
  }


  //Methods for step logic
  public contractStartStep1 = () => {
    this.plusOneStep();
  }

  public contractStartStep2 = () => {
    this.plusOneStep();

    this.setState({
      showNextButton: true
    });
  }

  public contractStartStep3 = () => {
    this.plusOneStep();
  }

  public contractStartStep4 = () => {
    this.plusOneStep();
  }

  public contractStartStep5 = () => {
    this.renewContract();
  }

  public changeTenantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantChoice: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      showNextButton: choice === "existingtenant" && this.state.selectedTenant ? true : false
    });
  }

  public changeOccupantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      occupantChoice: choice,
      occupantFirstName: "",
      occupantLastName: "",
      selectedOccupant: null
    });
  }

  public chooseTenantType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: ""
    });
  }

  public createTenant = () => {
    this.setState({
      occupantError: null //need for clear error for occupant fields
    }, () => {
      if (this.state.tenantType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                errorFields: [],
                tenant: person,
                showNextButton: true,
                selectedTenant: person,
                tenantChoice: "existingtenant"
              });
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                errorMessage: error.translatedMessage,
                isSaving: false
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company",
                contacts: this.state.tenantType === "company" ? {
                  ...this.getPayloadForPerson("tenant")
                } : undefined
              }
            },
            onSuccess: (company) => {
              const tenant = PersonFactory.create(company?.data?.contacts?.[0]);

              this.setState({
                companyTenant: company,
                tenant: tenant,
                showNextButton: true,
                errorFields: [],
                isSaving: false,
                selectedTenant: tenant,
                tenantChoice: "existingtenant"
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                errorMessage: error.translatedMessage,
                isSaving: false
              })
            }
          });
        });
      }
    })
  }

  public renderNotificationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.extensionDate, 6), "lastDate")}
        >
          6
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.extensionDate, 12), "lastDate")}
        >
          12
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.extensionDate, 24), "lastDate")}
        >
          24
        </div>
      </div>
    );
  }

  public renderExpirationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 1), "expirationDate")}
        >
          1
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 2), "expirationDate")}
        >
          2
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 4), "expirationDate")}
        >
          4
        </div>
      </div>
    );
  }

  public openTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  public addNewChargeTemplate = (): void => {
    const chargeTemplates = [...this.state.newChargeTemplates];

    let chargeTemplate = {
      amount: "",
      currency: this.props.app.settings.user.currency.getCurrencyId(),
      type: TypeContainer.pickIdFromLabel("Other_receivable"),
      repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
      description: "",
      paymentOffset: FirstDayOfPeriod.value,
      dueDateFirstPayment: new Date(),
      firstDate: new Date(),
      endDate: null,
      isDefault: false,
      oldAmount: "",
      isDummyPay: false,
      contactId: null,
      companyId: null,
      isCollective: true,
      percentage: "0",
      editedAmount: "",
      buttonDisabled: true
    }

    chargeTemplates.push(chargeTemplate);

    this.setState({ newChargeTemplates: [...chargeTemplates] });

    // this.forceUpdate();
  }

  public setNewChargeAmount = (event, index: number): void => {
    const amount: string = this.formatter.formatSigns(event.target.value);
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.map((template, ind) => {
        if (index === ind) {
          return {
            ...template,
            editedAmount: amount,
            buttonDisabled: false
          }
        }
        return template
      })
    })
  }

  public setChargeTemplateType = (event, index: number): void => {
    const type = event.target.value;
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.map((template, ind) => {
        if (index === ind) {
          return {
            ...template,
            type: type
          }
        }
        return template
      })
    })
  }

  public setChargeTemplateRepeatPeriod = (event, index: number): void => {
    const repeatPeriod = event.target.value;
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.map((template, ind) => {
        if (index === ind) {
          return {
            ...template,
            repeatPeriod: repeatPeriod
          }
        }
        return template
      })
    })
  }

  public saveNewChargeTemplate = (index: number): void => {
    const chargeTemplate = this.state.newChargeTemplates[index];
    chargeTemplate.amount = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(chargeTemplate.editedAmount)).replace(",", ".")).toFixed(2));
    chargeTemplate.oldAmount = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(chargeTemplate.editedAmount)).replace(",", ".")).toFixed(2));
    chargeTemplate.buttonDisabled = true;
    chargeTemplate.createdOnFrontend = true;
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.filter((_template, ind) => ind !== index),
      chargeTemplates: [...this.state.chargeTemplates, chargeTemplate]
    })
  }

  public onClearOccupant = (index) => {
    const additionalFields = this.state.additionalFields
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: additionalFields
    })
  }

  public addNewOccupant = (): any => {
    if (this.state.occupantChoice === "newoccupant") {
      const occupant = {
        person: {
          firstName: this.state.occupantFirstName,
          lastName: this.state.occupantLastName,
          description: this.state.occupantDescription,
          profession: "",
          email: "",
          phone1: "",
          phone2: "",
          contactRoleId: null,
          mainBankAccountId: "",
          companyId: null,
          address: {
            formattedAddress: ""
          },
          dateOfBirth: null,
          placeOfBirth: {
            formattedAddress: ""
          },
          identityNumber: "",
          identityType: 255,
          amazonFolderName: "",
          note: this.state.occupantDescription,
          pageTemplate: "person",
          genderTypeId: 3,
          languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
        }
      }

      this.saving(() => {
        this.props.dispatch({
          type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
          payload: occupant,
          onSuccess: occupant => {
            const occupantObj = {
              selectedPerson: occupant,
              description: occupant?.note,
              contactForContractTypeId: OccupantType.contactForContractTypeId
            }
            const additionalFields = [...this.state.additionalFields, occupantObj];

            this.setState({
              isSaving: false,
              errorFields: [],
              additionalFields: additionalFields,
              occupantError: null
            }, () => {
              this.setState({
                occupantFirstName: "",
                occupantLastName: "",
                occupantDescription: this.trans("label-occupant"),
                showAdditionalSection: false
              })
            });
          },
          onError: (err) => {
            this.setState({
              isSaving: false,
              errorFields: err.fields,
              errorMessage: err.translatedMessage,
              occupantError: err?.errorId
            });
          }
        });
      });
    }
    if (this.state.occupantChoice === "existingoccupant") {
      const occupantObj = {
        selectedPerson: this.state?.selectedOccupant,
        description: this.state?.occupantDescription,
        contactForContractTypeId: OccupantType.contactForContractTypeId
      }
      const additionalFields = [...this.state.additionalFields, occupantObj];
      this.setState({
        additionalFields: additionalFields,
        occupantError: null,
        showAdditionalSection: false,
        occupantChoice: "newoccupant",
        occupantDescription: this.trans("label-occupant")
      })
    }
  }

  public renderAdditionalFields = (): any => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
        {this.state.additionalFields?.length > 0 &&
          <div style={{ marginTop: "15px" }}>
            <div className="info-text">
              {this.trans("coach/newcontract-step/occupantscreated-info1")}
            </div>
            <ul>
              {
                this.state.additionalFields?.map((occupant, index) => {
                  return <li style={{ position: "relative" }}> {occupant.error &&
                    <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                      <span
                        className="icon icon-ic-info red"
                      >
                      </span>
                    </span>
                  }{`${occupant?.selectedPerson?.firstName}  ${occupant?.selectedPerson?.lastName || ""} ${occupant?.description !== "" ? `, ${occupant?.description}` : ""}`}<span style={{ cursor: "pointer" }} className="icon icon-ic-close clear-button clear-button-list" onClick={() => { this.onClearOccupant(index) }}></span></li>
                })
              }
            </ul>
          </div>
        }
        <div style={{ marginTop: "20px" }}>
          {this.trans("label-extra-persons")}
        </div>
        {this.state.showAdditionalSection &&
          <RadioGroup
            name="chargeOwnerChoice"
            className="filters-container"
            value={this.state.occupantChoice}
            onChange={this.changeOccupantChoice}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="newoccupant"
              label={this.trans("coach/renew-contract-step/new-person")}
              style={{ width: "auto", fontSize: "16px" }}
            />

            <FormControlLabel
              control={<Radio color="primary" />}
              value="existingoccupant"
              label={this.trans("coach/renew-contract-step/known-person")}
              style={{ width: "auto", fontSize: "16px" }}
            />
          </RadioGroup>
        }
        <div style={{ display: "flex", alignItems: "center" }}>
          {this.state.showAdditionalSection && this.state.occupantChoice === "newoccupant" &&
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "600px", marginRight: "20px" }}>
                <TextField
                  autoComplete="off"
                  // id="firstName"
                  // name="firstName"
                  className="form-element full-size scroll-to-firstName"
                  type="text"
                  label={this.trans("label-first-name")}
                  value={this.state.occupantFirstName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantFirstName")}
                  variant="standard"
                  error={!!this.state.occupantError}
                />
                {!!this.state.occupantError && <div className="component-error-text">{this.trans(this.state.occupantError)}</div>}
              </div>
              <TextField
                autoComplete="off"
                // id="lastName"
                // name="lastName"
                className="form-element full-size scroll-to-lastName"
                type="text"
                label={this.trans("label-last-name") + this.trans("field/optional")}
                value={this.state.occupantLastName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantLastName")}
                variant="standard"
                error={!!this.getErrorFor("contacts.lastName")}
              />
              {!!this.getErrorFor("contacts.lastName") && <div className="component-error-text">{this.getErrorFor("contacts.lastName")}</div>}
              <TextField
                autoComplete="off"
                className="form-element"
                style={{ minWidth: "110px", boxSizing: "border-box", marginLeft: "16px" }}
                type="text"
                label={this.trans("label-description")}
                value={this.state?.occupantDescription}
                onChange={e => {
                  this.setState({
                    occupantDescription: (e.currentTarget as any).value
                  });
                }}
                variant="standard"
                error={false}
              />
            </div>
          }
          {this.state.showAdditionalSection && this.state.occupantChoice === "existingoccupant" &&
            <div style={{ display: "flex", width: "100%" }}>
              <PersonLookup
                {...this.props}
                filterOutEntities={this.state.additionalFields}
                isInlineBlock={true}
                width="100%"
                containerWidth="100%"
                styleInModal={"pick-object-modal"}
                autoSelectId={this.state?.selectedOccupant?.id}
                floatingLabelText={this.trans("dropdown-selectperson-label")}
                onSelect={this.selectAdditionalPerson}
                onClear={person => {
                  this.setState({
                    selectedOccupant: null,
                    ignoredPeople: this.state.ignoredPeople.filter(p => p.id !== person.id)
                  });
                }}
                forceUpdatePage={false}
                hideClickThroughLink={true}
                disableEntityCreation={true}
                dropdownStyles={{ minWidth: "fit-content" }}
              />

              <TextField
                autoComplete="off"
                className="form-element"
                style={{ minWidth: "200px", boxSizing: "border-box", marginLeft: "16px" }}
                type="text"
                label={this.trans("label-description")}
                value={this.state?.occupantDescription}
                onChange={e => {
                  this.setState({
                    occupantDescription: (e.currentTarget as any).value
                  });
                }}
                variant="standard"
                error={false}
              />
            </div>
          }
          {this.state.showAdditionalSection &&
            <Button
              color="primary"
              onClick={this.addNewOccupant}
              variant={"contained"}
              style={{ textAlign: "right", marginLeft: "16px" }}
            >
              {this.trans("button-save")}
            </Button>
          }
        </div>

        {!this.state.showAdditionalSection &&
          <div className="coach-new-property-add-button">
            <Button
              color="primary"
              onClick={() => { this.setState({ showAdditionalSection: true }) }}
              variant={"outlined"}
              style={{ textAlign: "right" }}
            >
              {this.state.showAdditionalSection ? this.trans("button-save") : this.trans("coach/newcontract-step/tenant-button/addperson-label")}
            </Button>
          </div>}
      </div>
    );
  }

  public selectAdditionalPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      hasModifiedData: isManuallySelected,
      selectedOccupant: person,
      ignoredPeople: [person, ...this.state.ignoredPeople]
    });
  }

  public removeAdditionalField = (index: number): void => {
    const additionalFields = [...this.state.additionalFields];
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: [...additionalFields],
      hasModifiedData: true
    });
  }

  public removeChargeTemplate = (index: number): void => {
    const chargeTemplates = [...this.state.chargeTemplates];
    chargeTemplates.splice(index, 1);

    // A rejected row's path holds its place in the list, so the marks wait for the next Finish.
    this.setState({
      chargeTemplates: [...chargeTemplates],
      hasModifiedData: true,
      errorFields: []
    });
  }

  public removeNewChargeTemplate = (index: number): void => {
    const chargeTemplates = [...this.state.newChargeTemplates];
    chargeTemplates.splice(index, 1);

    this.setState({
      newChargeTemplates: [...chargeTemplates],
      hasModifiedData: true
    });
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface, fromCoach: boolean): void => {
    this.setState({
      selectedTenant: entity,
      ignoredPeople: entity instanceof Person ? [entity, ...this.state.ignoredPeople] : [...this.state.ignoredPeople],
      hasModifiedData: true,
      showNextButton: this.state.selectedUnit ? true : false,
      openCoachCreateNewTenant: (entity instanceof Company && !entity?.generalContactId && !fromCoach) ? true : false,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (entity instanceof Person) {
          if (entity?.id) {
            contactId = entity?.id;
            companyId = undefined;
          }
        }

        if (entity instanceof Company) {
          if (entity?.id) {
            companyId = entity?.id;
            contactId = undefined;
          }
        }

        return {
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        }
      })
    });
  }

  public clearTenant = (): void => {
    this.setState({
      selectedTenant: null,
      hasModifiedData: true,
      showNextButton: false,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (this.state.selectedTenant instanceof Person) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.contactId && this.state.selectedTenant?.id === chargeTemplate?.contactId)) {
            contactId = null;
            companyId = undefined;
          }
        }

        if (this.state.selectedTenant instanceof Company) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.companyId && this.state.selectedTenant?.id === chargeTemplate?.companyId)) {
            companyId = null;
            contactId = undefined;
          }
        }

        return {
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        }
      })
    });
  }
  public changeAutoSendInvoiceToTenant = () => {
    this.setState({
      autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant,
      hasModifiedData: true
    });
  }

  public changeIsCommercial = () => {
    this.setState({
      isCommercial: !this.state.isCommercial,
      hasModifiedData: true
    });
  }

  public clearContract = () => {
    this.setState({
      contract: null,
      showNextButton: false,
      additionalFields: []
    });
  }

  public selectContract = (contract: ContractInterface): void => {
    this.setState({
      ...this.getStateForContract(contract),
      errorFields: [],
      errorMessage: null,
      newChargeTemplates: [],
      hasModifiedData: true
    });
  }

  public clearBackEndErrors = () => {
    this.setState({
      errorFields: [],
      errorMessage: ""
    });
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public onClear = (index) => {
    const chargeTemplates = this.state.chargeTemplates
    chargeTemplates.splice(index, 1);

    this.setState({
      chargeTemplates: chargeTemplates
    })
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;
    const prevExtensionDate = !!this.state.extensionDate ? new Date(this.state.extensionDate) : null;
    // const prevLastDate = !!this.state.lastDate ? new Date(this.state.lastDate) : null;
    // const prevFinalDate = !!this.state.finalRentalPeriodDate ? new Date(this.state.finalRentalPeriodDate) : null;
    // const prevExpirationDate = !!this.state.expirationDate ? new Date(this.state.expirationDate) : null;

    // Update the state
    this.setState({
      [identifier]: date,
      hasModifiedData: true,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.extensionDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.extensionDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "extensionDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component
        this.setState({
          chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
            let chargeTemplateFirstDate = chargeTemplate?.firstDate;
            let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

            if (!!this.state.extensionDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!this.state.extensionDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !prevExtensionDate && !chargeTemplate?.firstDate) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }

            if (!this.state.extensionDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !prevExtensionDate && !chargeTemplate?.dueDateFirstPayment) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }
            return {
              ...chargeTemplate,
              firstDate: chargeTemplateFirstDate,
              dueDateFirstPayment: chargeTemplateDueDateFirstPayment
            }
          })
        });
        return this.selectDate(Time.nextYearPrevMonthLastDay(Time.substractMonth(this.state.extensionDate, this.props.app.settings.agency.notificationPeriod - 1)), "expirationDate");
        // we should update last date if it wasn't changed manually
        // if (!!this.state.extensionDate && !!this.state.lastDate &&
        //   this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevExtensionDate)) === this.formatter.formatDate(this.state.lastDate)) {
        //     return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.extensionDate), "lastDate");

        // }

        // if (!this.state.extensionDate && !!this.state.lastDate &&
        //     this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevExtensionDate)) === this.formatter.formatDate(this.state.lastDate)) {
        //       return this.selectDate(this.state.extensionDate, "lastDate");
        // }

        // if (!!this.state.extensionDate && !prevExtensionDate && !this.state.lastDate) {
        //   return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.extensionDate), "lastDate");
        // }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      // if (identifier === "lastDate") {
      //   if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
      //     this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
      //       this.selectDate(this.state.lastDate, "finalDate");
      //   }

      //   if (!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
      //     this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
      //      this.selectDate(date, "finalDate");
      //   }

      //   if (!!this.state.lastDate && !prevLastDate && !prevFinalDate) {
      //     this.selectDate(date, "finalDate");
      //   }

      //   if (!!this.state.lastDate && !!this.state.expirationDate &&
      //     this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
      //       return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
      //   }

      //   if (!this.state.lastDate && !!this.state.expirationDate &&
      //       this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
      //       return this.selectDate(this.state.lastDate, "expirationDate");
      //   }

      //   if (!!this.state.lastDate && !prevLastDate && !prevExpirationDate) {
      //     return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
      //   }
      // }
    });
  }

  public openCalculatePricePopup = (chargeTemplate, index): any => {
    const priceOldAmount = chargeTemplate?.oldAmount ?
      this.formatter.simpleFormatNumber(chargeTemplate?.oldAmount * 100) :
      this.formatter.simpleFormatNumber(chargeTemplate?.amount * 100);

    this.setState({
      selectedChargeIndex: index,
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      priceOldAmount: priceOldAmount,
      priceNewAmount: this.formatter.simpleFormatNumber(chargeTemplate?.amount * 100)
    });
  }

  public changePriceNewAmount = (event, index: number): void => {
    const newAmount: string = this.formatter.formatSigns(event.target.value);
    const newTemplateArr = this.state.chargeTemplates?.map((template, rowIndex) => {
      if (rowIndex === index) {
        template.editedAmount = newAmount;
        template.buttonDisabled = false;
      }
      return template
    })
    this.setState({
      chargeTemplates: newTemplateArr
    });
  }

  public changePricePercentage = (event, index: number): void => {
    const percentage: string = this.formatter.formatSigns(event.target.value);
    const percentageNumber: number = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(percentage)).replace(",", ".")).toFixed(2));
    const newTemplateArr = this.state.chargeTemplates?.map((template, rowIndex) => {
      if (rowIndex === index) {
        const newAmount = template?.oldAmount + template?.oldAmount * (percentageNumber / 100);
        template.editedAmount = isNaN(newAmount) ? 0 : this.formatter.simpleFormatNumber(newAmount * 100);
        template.percentage = percentage;
        template.buttonDisabled = false;
      }
      return template
    })

    this.setState({
      chargeTemplates: newTemplateArr
    });
  }

  public updatePrice = (index: number) => {
    const newTemplateArr = this.state.chargeTemplates?.map((template, rowIndex) => {
      if (rowIndex === index) {
        template.isChanged = true;
        template.amount = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(template.editedAmount)).replace(",", ".")).toFixed(2));
        template.buttonDisabled = true;
        template.error = false;
        template.isPriceCorrected = true;
      }
      return template
    })

    this.setState({
      showNextButton: true,
      chargeTemplates: newTemplateArr
    })

  }

  public getPayloadTenant = (): any => {
    const pageTemplate = "tenant";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName: type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public isNextButtonDisabled = () => {
    if (this.state.activeStep === 0 && !this.state.contract) {
      return true
    }
    if ((this.state.activeStep === 1 && !this.state.selectedTenant) || (this.state.activeStep === 1 && !this.state.selectedUnit)) {
      return true
    }
    if (this.state.activeStep === 2 && this.state.chargeTemplates?.length === 0) {
      return true
    }
    if (this.state.activeStep === 3 && !this.state.extensionDate) {
      return true
    }
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openCoachRenewContract}
          onCloseCoach={this.onCloseRenewContractCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({ activeStep, isDisabled: false })
          }}
          showBackButton={true}
          disabled={false}
          disabledBack={false}
          disabledNext={this.isNextButtonDisabled()}
          useButtonStripForCoach={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
